import {
    PICK_LIVE_MATHS_LEVEL,
    RESET_LIVE_MATHS_LEVEL
} from './live-maths-level-picker-actions';

const defaultState = 1;

/**
 * Live Maths Level Reducer
 *
 * Consumes PICK_LIVE_MATHS_LEVEL action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {number} - current Live Maths level
 */
export default function(state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
        case PICK_LIVE_MATHS_LEVEL:
            return action.payload;

        case RESET_LIVE_MATHS_LEVEL:
            return defaultState;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./components/live-maths-level-picker/live-maths-level-reducer.js